import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { SCOUT_SETTINGS_FILTER } from '../../../../../../constants';

const useFilterOptions = () => {
  const { t } = useTranslation('settings');

  return useMemo(
    () => [
      {
        label: t('writer'),
        value: SCOUT_SETTINGS_FILTER.WRITER,
      },
      {
        label: t('textLength'),
        value: SCOUT_SETTINGS_FILTER.TEXT_LENGTH,
        disabled: true,
      },
    ],
    [t],
  );
};

export default useFilterOptions;
